<app-page-heading [title]="selectedCarrier ? selectedCarrier.name + '\'s drivers' : 'Drivers'"></app-page-heading>

<section class="container-fluid summary-panel">
    <div class="row">
        <div class="col-xs-12">

            <select id="carrier-select" class="form-control input-lg" [(ngModel)]="selectedCarrier" (change)="goToDrivers(selectedCarrier.id)">
                <option *ngFor="let carrier of carriers" [ngValue]="carrier">{{carrier.name}}</option>
            </select>

            <button class="btn btn-primary btn-lg pull-right m-l-sm" [disabled]="!selectedCarrier || selectedCarrier.blocked" (click)="goToCreateDriver(selectedCarrier.id)">
                <span class="fa fa-plus"></span> Create Driver
            </button>

            <button class="btn btn-info btn-lg pull-right m-l-sm" [disabled]="!selectedCarrier" (click)="goToManagers(selectedCarrier.id)">
                <span class="fa fa-eye"></span> View Carrier Managers
            </button>

            <button class="btn btn-info btn-lg pull-right" [disabled]="!selectedCarrier" (click)="goToSubcontractors(selectedCarrier.id)">
                <span class="fa fa-eye"></span> View Sub-carriers
            </button>
        </div>
    </div>

    <div class="m-t-sm">
        <app-data-filters #dataFilters [disableSearch]="emailFilter.minLengthInvalid" [size]="495">
            <app-data-filter-group>
                <app-data-filter-input
                    #emailFilter
                    [labelKey]="'user-dashboard.users.list.filters.email.label'"
                    [(model)]="filters.email"
                    [minLength]="3"
                    [helperKey]="'Enter at least three characters'"
                    [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
            </app-data-filter-group>
        </app-data-filters>
    </div>

    <br>

    <div class="alert alert-warning" *ngIf="selectedCarrier && selectedCarrier.blocked">
        <i class="fa fa-warning"></i>
        <em>This carrier is currently disabled.</em>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table #userTable [loadPage]="loadPage"
                                    [showCarrier]="true"
                                    [showSubcontractor]="true"
                                    [(filters)]="filters"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    (edit)="goToEditDriver(selectedCarrier.id, $event)">
                    </app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
